export default "/_next/static/images/mydecororganizer-modal-ec2e2062d5b15d4e927fd91a6b9e8502.png";